/* eslint-disable radix */
/* eslint-disable no-useless-return */
import { hasValue, isNullOrUndefined, safeParseJSON } from '../general-helpers';

export const getNumberFromLocalStorage = (key = '') => {
    try {
        return parseInt(localStorage.getItem(key) || '');
    } catch (error) {
        return 0;
    }
};

export const setNumberInLocalStorage = (key, value) => {
    if (isNullOrUndefined(value)) {
        return;
    }

    try {
        localStorage.setItem(key, value.toString());
    } catch (error) {
        return;
    }
};

export const deleteFromLocalStorage = (key) => {
    try {
        localStorage.removeItem(key);
    } catch (error) {
        return;
    }
};

export const deleteItemsFromLocalStorage = (keys) => {
    if (!hasValue(keys)) {
        return;
    }

    keys.forEach((key) => {
        deleteFromLocalStorage(key);
    });
};

export const getStringFromLocalStorage = (key) => {
    try {
        return localStorage.getItem(key);
    } catch (error) {
        return '';
    }
};

export const setLocalStorageItem = (key, value) => {
    if (isNullOrUndefined(value)) {
        return;
    }

    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        return;
    }
};

export const getLocalStorageItem = (key, deleteItem = false) => {
    try {
        const item = safeParseJSON(localStorage.getItem(key));

        if (deleteItem) {
            localStorage.removeItem(key);
        }

        return item;
    } catch (error) {
        return undefined;
    }
};

export const getLocalStorageItems = (keys = []) => {
    const result = {};

    if (!hasValue(keys)) {
        return {};
    }

    keys.forEach((key) => {
        result[key] = getLocalStorageItem(key);
    });

    return result;
};
